import classNames from 'classnames'

import { getQaSelector } from '../../utils/common'
import { Skeleton } from '../Skeleton'

import {
  QA_NAME_TABLE_SKELETON,
  TABLE_SKELETON_CELL_WIDTH,
  TABLE_SKELETON_ROWS,
} from './TableSkeleton.constants'
import { getCellWidth, getIsScrollButtonRow } from './TableSkeleton.utils'

import * as styles from './TableSkeleton.module.css'

function TableSkeleton({
  cellWidth = TABLE_SKELETON_CELL_WIDTH,
  className,
  headerRowClassName,
  inline,
  qaName,
  rowClassName = styles.TableSkeletonRow,
  rows = TABLE_SKELETON_ROWS,
  withCheckbox = true,
}) {
  const resolvedClassName =
    className ?? (inline ? styles.TableSkeletonInline : styles.TableSkeleton)

  const qaProps = getQaSelector({
    context: QA_NAME_TABLE_SKELETON,
    def: QA_NAME_TABLE_SKELETON,
    value: qaName,
  })

  return (
    <div {...qaProps} className={resolvedClassName}>
      <div className={headerRowClassName ?? rowClassName}>
        <Skeleton
          className={classNames(styles.skeleton, styles.skeletonHeader)}
        />
      </div>
      {Array.from({ length: rows }).map((_, index) => (
        <div className={rowClassName} key={index}>
          {withCheckbox ? (
            <Skeleton
              className={classNames(styles.skeleton, styles.skeletonCheckbox)}
            />
          ) : null}
          <Skeleton
            className={styles.skeleton}
            style={{ width: getCellWidth(index, cellWidth) }}
          />
          {getIsScrollButtonRow(index, rows) ? (
            <Skeleton className={styles.skeletonScrollButton} />
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default TableSkeleton
